<!--
 * @Author: your name
 * @Date: 2021-05-20 11:07:43
 * @LastEditTime: 2021-05-25 16:09:38
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \VtpWechatUI\src\components\HelloWorld.vue
-->
<template>
  <div style="" v-show="noticeshow">
    <div class="weui-mask"></div>
    <div class="weui-dialog" style="overflow:scroll">
      <div class="weui-dialog__hd" style="padding-top: 15px;padding-bottom: 12px"><strong class="weui-dialog__title">入园须知</strong></div>
      <!-- <div class="weui-dialog__bd">弹窗内容，告知当前页面信息等</div> -->
      <div v-for="item in noticelist" :key="item.value" class="noticeContent" style="font-size: smaller;" >
        {{item}}
      </div>
      <div class="weui-btn-area">
        <button class="weui-btn weui-btn_primary" @click="doRead" style="background-color: #169BD5;color:#FFFFFF">我已知悉</button>
      </div>
    </div>
  </div>
</template>

<script>
import { getAction, postAction } from '../request/http'
// import { Dialog } from 'vue-weui'
export default {
  name: 'HelloWorld',
  components: {
    // Dialog
  },
  data() {
    return {
      noticelist: '',
      noticeshow: true,
      dialogControl: true,
      show: false,
      show1: false,
      model: {},
      screenWidth: document.body.clientWidth, // 屏幕宽
      datalist: [],
      lists: [],
      pageInfo: {
        currentPage: 1, // 当前页面
        pageSize: 10,
        totalCount: 0, // 总数
        sord: 'desc',
        sidx: 'id'
      }
    }
  },
  computed: {

  },
  created() {
    getAction("/vtp/toaEnterParkApply/admissionotice").then((res) => {
      if (res.data.success) {
        this.noticelist = res.data.result
      }
    })
  },
  mounted() {
    // getAction("/vtp/toaEnterParkApply/list", this.pageInfo).then((res) => {
    //   this.datalist = res.data.result.dataList
    // })
  },
  methods: {
    doRead() {
      this.noticeshow = false
      this.$router.push({
        name: 'edit',
        params: {
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.noticeContent {
  width: 90%;
  padding: 3px;
  margin-left: 3%;
  text-align: left;
}
.link-top {
  width: 100%;
  height: 1px;
  border-top: solid #acc0d8 1px;
}
.bannercontainner {
  padding: 15px;
}
.gonggao {
  flex: 1;
  background-color: rgb(252, 104, 72);
  border-radius: 15px;
  height: 35px;
  line-height: 35px;
}
.banner {
  background-image: url('../assets/banner.jpg');
  background-size: 100% 100%;
}
.greeBack {
  background-color: green;
}
.gonggaocontainer {
  padding: 5px;
}
.gonggaocontent {
  flex: 4;
  height: 35px;
  text-align: left;
  line-height: 35px;
  text-indent: 15px;
}
.line {
  margin-top: 5px;
  background-color: rgb(246, 246, 246);
  height: 2px;
}
.linecontainer {
  padding-left: 10px;
  padding-right: 10px;
}
.enterParkApplyleftcontent {
  background-image: url('../assets/enterParkApply.jpg');
  background-size: 100% 100%;
  border-radius: 15px;
}
.allfunction {
  padding-top: 20px;
}
.enterParkApplyrightcontent1 {
  background-image: url('../assets/applyHistory.jpg');
  background-size: 100% 100%;
  margin-top: 10px;
  border-radius: 15px;
}
.enterParkApplyrightcontent2 {
  background-image: url('../assets/cancelApply.jpg');
  background-size: 100% 100%;
  margin-top: 10px;
  border-radius: 15px;
}
.enterParkApplycontainer {
  padding: 10px;
}
.enterParkApplyrightcontainer {
  padding-left: 0px;
  padding-right: 10px;
  padding-top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/AdmissionNotice.vue